import { httpGet, httpPost, httpDelete } from "@/request/http";

export default {
  getModules() {
    return httpGet(`/specificationtypemodules/groups`);
  },
  getSpecificationType(id) {
    return httpGet(`/specificationtypes/${id}`);
  },
  saveSpecificationTypes(dTO) {
    return httpPost(`/specificationtypes/group`, dTO);
  },
  removeSpecificationType(id) {
    return httpDelete(`/specificationtypes/${id}`);
  },
  getSpecificationTypeModule(id) {
    return httpGet(`/specificationtypemodules/${id}`);
  },
  saveSpecificationTypeModule(dTO) {
    return httpPost(`/specificationtypemodules`, dTO);
  },
  removeSpecificationTypeModule(id) {
    return httpDelete(`/specificationtypemodules/${id}`);
  },
  getSpec(id) {
    return httpGet(`/specificationmodules/${id}`);
  },
  saveSpec(dTO) {
    return httpPost(`/specificationmodules`, dTO);
  },
  removeSpec(id) {
    return httpDelete(`/specificationmodules/${id}`);
  },
  getSpecificationModules(id) {
    return httpGet(`/specificationtypemodules/${id}/specificationmodules`);
  },
};
